import React, { useState } from "react";
import { resetPasswordValidations, emailValidation } from "../../Utility/Validations";
import { Auth, API, graphqlOperation } from "aws-amplify";
import toast from "react-hot-toast";
import { sendHubspotEmail } from "../../graphql/queries";
import { changePasswordLogoutProcess, getTenantInfo } from "../../Utility/ApiService";

export default function ForgotPassword({ setModalSuccess, setLoading, setShowForgotPassword, showForgotPassword }) {
  const [showEmail, setShowEmail] = useState(true);
  const [email, setEmail] = useState();
  const [passwordToggle, setPasswordToggle] = useState({
    password: false,
    conPassword: false,
  });
  const [resetPassInfo, setResetPassInfo] = useState({
    code: "",
    password: "",
    confirmPassword: "",
  });
  const [resetPassErrors, setResetPassErrors] = useState({});

  const checkValidations = () => {
    if (showEmail) {
      const emailError = emailValidation(email);
      if (!emailError) {
        handleSendCode(email);
      } else {
        toast.error(emailError);
      }
    } else {
      const resetError = resetPasswordValidations(resetPassInfo);
      setResetPassErrors(resetError);
      if (!resetError?.code && !resetError?.password && !resetError?.confirmPassword && resetError.empty === true) {
        onChangePassword();
      }
    }
  };

  const handleSendCode = async () => {
    setLoading(true);
    Auth.forgotPassword(email)
      .then(() => {
        showSuccessMessage("Resend code sent successfully. Please check your mail");
        setShowEmail(false);
      })
      .catch((err) => {
        toast.error("Email doesn't exist");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onChangePassword = async () => {
    try {
      setLoading(true);
      await Auth.forgotPasswordSubmit(email, resetPassInfo.code, resetPassInfo.password);
      await Auth.signIn(email, resetPassInfo.password);
      const tenant_user = await getTenantInfo(email);

      if (tenant_user && tenant_user.length > 0) {
        const tenant_id = tenant_user[0].id;
        await API.graphql(
          graphqlOperation(sendHubspotEmail, {
            id: tenant_id,
            role: "Tenant",
            code: "CPASS",
            data: JSON.stringify({
              email: email,
            }),
          })
        );
        showSuccessMessage("Your password has been changed successfully. You can login now!");
        await changePasswordLogoutProcess(tenant_id);
        setShowForgotPassword(false);
      } else {
        toast.error("The email does not exists");
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("Error Change Passsword", err);
      toast.error("The Code You have Provided is invalid");
    }
  };

  const showSuccessMessage = (message) => {
    setModalSuccess(message);
    setTimeout(() => {
      setModalSuccess();
    }, 2000);
  };

  return (
    <div>
      <div>
        <div className="d-flex justify-content-end">
          <i
            className="fa fa-home cursor-pointer "
            onClick={() => {
              if (!showEmail) {
                setShowEmail(true);
              } else if (showForgotPassword) {
                setShowEmail(false);
                setShowForgotPassword(false);
              }
            }}
            style={{ fontSize: "25px", marginBottom: 20 }}
          />
        </div>

        <div>
          <h3> {showEmail ? "Forgot Password" : "Password Reset"}</h3>
          <h5>
            {showEmail
              ? "Enter your email address and we'll send a verification code to change your password"
              : `Enter the code we've sent by email to ${email} `}
            {!showEmail && (
              <a style={{ cursor: "pointer" }} onClick={() => setShowEmail(true)}>
                <h6 style={{ color: "#000", fontWeight: "bold" }}>Change</h6>
              </a>
            )}
          </h5>
        </div>

        <div className="auth-form-content">
          <div className="with-email">
            <form>
              {showEmail && (
                <div className={"mb-3"}>
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Enter Email"
                    defaultValue={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                </div>
              )}

              {!showEmail && (
                <div className={"mb-3 " + (resetPassErrors?.code && "error")}>
                  <label htmlFor="email" className="form-label">
                    Code
                  </label>
                  <input
                    length={6}
                    type=""
                    className="form-control"
                    id="code"
                    placeholder="Enter Code"
                    defaultValue={resetPassInfo.code}
                    onChange={(e) => {
                      setResetPassInfo({
                        ...resetPassInfo,
                        code: e.target.value,
                      });
                    }}
                  />
                  {resetPassErrors?.code && <p>{resetPassErrors?.code}</p>}
                </div>
              )}

              {!showEmail && (
                <div style={{ marginLeft: "72%" }}>
                  <a
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => handleSendCode()}
                  >
                    <h6
                      style={{
                        color: "#000",
                        fontWeight: "bold",
                      }}
                    >
                      Resend Code
                    </h6>
                  </a>
                </div>
              )}

              {!showEmail && (
                <div className={"mb-3 " + (resetPassErrors?.password && "error")}>
                  <label htmlFor="password" className="form-label">
                    New Password
                  </label>
                  <div className="field-group">
                    <input
                      autoComplete="on"
                      className="form-control input-password"
                      id="password"
                      type={passwordToggle?.password ? "text" : "password"}
                      placeholder="Create New Password"
                      defaultValue={resetPassInfo.password}
                      onChange={(e) => {
                        setResetPassInfo({
                          ...resetPassInfo,
                          password: e.target.value,
                        });
                      }}
                    />
                    <span
                      onClick={(e) => {
                        setPasswordToggle({
                          ...passwordToggle,
                          password: !passwordToggle?.password,
                        });
                      }}
                      toggle="#password"
                      className={
                        passwordToggle?.password ? "fa fa-eye toggle-password" : "fa fa-eye-slash toggle-password"
                      }
                    />
                  </div>
                  {resetPassErrors?.password && <p>{resetPassErrors?.password}</p>}
                </div>
              )}

              {!showEmail && (
                <div className={"mb-3 " + (resetPassErrors?.confirmPassword && "error")}>
                  <label htmlFor="password" className="form-label">
                    Reenter Password
                  </label>
                  <div className="field-group">
                    <input
                      autoComplete="on"
                      className="form-control input-password"
                      id="password"
                      type={passwordToggle?.conPassword ? "text" : "password"}
                      placeholder="Reenter Password"
                      defaultValue={resetPassInfo?.confirmPassword}
                      onChange={(e) => {
                        setResetPassInfo({
                          ...resetPassInfo,
                          confirmPassword: e.target.value,
                        });
                      }}
                    />
                    <span
                      onClick={() => {
                        setPasswordToggle({
                          ...passwordToggle,
                          conPassword: !passwordToggle?.conPassword,
                        });
                      }}
                      toggle="#password"
                      className={
                        passwordToggle?.conPassword ? "fa fa-eye toggle-password" : "fa fa-eye-slash toggle-password"
                      }
                    />
                  </div>
                  {resetPassErrors?.confirmPassword && <p>{resetPassErrors?.confirmPassword}</p>}
                </div>
              )}

              <button
                type="submit"
                className="btn btn-primary w-100"
                onClick={(e) => {
                  e.preventDefault();
                  checkValidations();
                }}
              >
                {showEmail ? "Next" : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
